import React from "react";
import { Link } from "react-router-dom";

import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import { ISponsor } from "@src/types/api";

import { SPONSOR_LOGO_URL } from "@lib/globals";

const SortableRow = ({ sponsor }: { sponsor: ISponsor }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id: sponsor.id });

    return (
        <tr
            ref={setNodeRef}
            style={{
                transform: CSS.Transform.toString(transform),
                transition,
            }}
            {...attributes}
            className={isDragging ? "dragging" : ""}
        >
            <td>
                <div {...listeners} className="drag-handle">
                    ⋮⋮
                </div>
            </td>
            <td>{sponsor.sortOrder}</td>
            <td>
                {sponsor.logo && (
                    <img
                        src={`${SPONSOR_LOGO_URL}${sponsor.logo}`}
                        alt={`${sponsor.name} logo`}
                        className="sponsorLogo"
                    />
                )}
            </td>
            <td>{sponsor.name}</td>
            <td>
                <Link
                    to={`/site-management/advertisers/${sponsor.id}`}
                    className="btn btn-primary"
                >
                    Edit
                </Link>
            </td>
        </tr>
    );
};

export default SortableRow;
